// extracted by css-extract-rspack-plugin
export default {"IconWrapper":"JNVMB","DismissIconButtonWrapper":"l44nO z4qKh","Body":"Gie5_"};